import { Theme } from '@mui/material';

export const hasSameValues = <T>(values: T[], otherValues: T[]) =>
  values.length === otherValues.length && values.every((value) => otherValues.includes(value));

export const inlineEditErrorOutline = (theme: Theme, hasError?: boolean) =>
  hasError ? { boxShadow: `inset 0 0 0 1px ${theme.palette.error.main}` } : {};
